<template>
  <div>
    <section class="content-header">
      <h1>
        <span
          v-text="scenario.id ? $ml.get('scenarios.scenarioDetails') : $ml.get('scenarios.newScenario')"
        ></span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <i class="fa fa-bookmark"></i>
          <span>{{$ml.get('shared.scenarioList')}}</span>
        </li>
        <li>
          <span
            v-text="scenario.id ? $ml.get('scenarios.scenarioDetails') : $ml.get('scenarios.newScenario')"
          ></span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12" style="margin-bottom:10px;">
          <button @click="backToScenarioList()" class="btn btn-primary pull-right">
            <i class="fa fa-mail-reply"></i>
            {{$ml.get('scenarios.backToScenarios')}}
          </button>
        </div>
        <div class="col-sm-12">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('scenarios.scenarioDetails')}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Senaryo Adı</label>
                    <input type="text" class="form-control" v-model="scenario.name" />
                  </div>
                  <div class="form-group">
                    <label>Senaryo Tipi</label>
                    <br />
                    <div class="btn-group">
                      <button
                        type="button"
                        :class="scenario.type == 1 ? 'btn btn-primary' : 'btn btn-default'"
                      >
                        <i class="fa fa-clock-o"></i> Zaman Bazlı
                      </button>
                      <button
                        disabled
                        type="button"
                        :class="scenario.type == 2 ? 'btn btn-primary' : 'btn btn-default'"
                      >
                        <i class="fa fa-exclamation-triangle"></i> Olay Bazlı
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-6">
                      <div v-show="!scenario.id" class="form-group">
                        <label>Gün</label>
                        <br />
                        <div
                          @click="day.check = !day.check"
                          style="cursor:pointer;margin-left:20px;"
                          v-for="day in dayList"
                          :key="day.value"
                        >
                          <i
                            v-show="day.check"
                            class="fa fa-check-circle text-success"
                            style="font-size:18px;"
                          ></i>
                          <i
                            v-show="!day.check"
                            class="fa fa-times-circle text-danger"
                            style="font-size:18px;"
                          ></i>
                          <span>{{day.name}}</span>
                        </div>
                      </div>
                      <div v-show="scenario.id" class="form-group">
                        <label>Gün</label>
                        <select @change="changeDay($event)" class="form-control">
                          <option
                            :selected="scenario.day == 0"
                            value="0"
                          >{{$ml.get('general.select')}}</option>
                          <option
                            v-for="day in dayList"
                            :key="day.value"
                            :value="day.value"
                            :selected="day.value == scenario.day"
                          >{{day.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Saat</label>
                        <input type="time" class="form-control" v-model="scenario.time" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>İşlem Yapılacak Terminaller</label>
                    <div class="input-group">
                      <label
                        v-show="checkedDeviceList != ''"
                        class="form-control tdb-box"
                      >{{checkedDeviceList}}</label>
                      <label
                        v-show="checkedDeviceList == ''"
                        class="form-control"
                      >{{$ml.get('general.notSelected')}}</label>
                      <div class="input-group-btn">
                        <button
                          class="btn btn-primary"
                          data-toggle="modal"
                          data-target="#modal-select-device"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                        <button
                          v-show="checkedDeviceList != ''"
                          class="btn btn-danger"
                          @click="clearDevices()"
                        >
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Komut</label>
                    <select @change="changeCommand($event)" class="form-control">
                      <option :selected="scenario.command" value="1">Alarm Tetikle</option>
                    </select>
                  </div>
                  <button @click="saveScenario()" class="btn btn-success" style="width:100%;">
                    <i class="fa fa-check"></i>
                    {{$ml.get('general.save')}}
                  </button>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--TERMINAL SEÇ MODAL -->
    <div class="modal modal-secondary fade" id="modal-select-device" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">
              <span>İşlem Yapılacak Terminal</span>
            </h4>
          </div>
          <div class="modal-body">
            <input
              type="text"
              :placeholder="$ml.get('general.search')"
              v-model="searchText"
              class="form-control"
              autocomplete="false"
              style="margin-bottom:10px;"
            />
            <div class="table-responsive" style="max-height:500px;owerflow:auto;">
              <span
                class="form-control"
                v-for="device in deviceList"
                :key="device.id"
                @click="device.check==true ? device.check=false : device.check=true"
                style="cursor:pointer;"
              >
                <span style="font-size:15px;">
                  <i v-show="device.check" class="fa fa-check-circle text-success"></i>
                  <i v-show="!device.check" class="fa fa-times-circle text-danger"></i>
                </span>
                {{device.name}} ({{device.ip}})
              </span>
              <div
                class="callout callout-warning"
                v-show="deviceList.length == 0"
              >{{$ml.get('alerts.recordNotFound')}}</div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              <i class="fa fa-check"></i>
              {{$ml.get('general.done')}}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--TERMINAL SEÇ MODAL END -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      scenarios: [],
      scenario: {
        id: this.$route.params.id,
        name: "",
        type: 1,
        day: 0,
        days: [],
        time: null,
        command: 1,
        terminalList: []
      },
      days: [
        { value: 1, name: this.$ml.get("general.monday"), check: true },
        { value: 2, name: this.$ml.get("general.tuesday"), check: true },
        { value: 3, name: this.$ml.get("general.wednesday"), check: true },
        { value: 4, name: this.$ml.get("general.thursday"), check: true },
        { value: 5, name: this.$ml.get("general.friday"), check: true },
        { value: 6, name: this.$ml.get("general.saturday"), check: true },
        { value: 7, name: this.$ml.get("general.sunday"), check: true }
      ],
      devices: [],
      searchText: ""
    };
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 530;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    dayList() {
      return this.days;
    },
    checkedDeviceList() {
      var checkedList = "";
      var list = this.devices.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    deviceList() {
      if (this.searchText != "") {
        return this.devices.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(
              v => item.name.toUpperCase().includes(v) || item.ip.includes(v)
            );
        });
      } else {
        return this.devices.sort((a, b) => {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      }
    },
    scenarioList() {
      return this.scenarios;
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    backToScenarioList() {
      this.$router.push("/scenario-list");
    },
    changeDay(event) {
      this.scenario.day = event.target.value;
    },
    changeRepeat(event) {
      if (event.target.value == "1") {
        this.scenario.repeat = true;
      } else {
        this.scenario.repeat = false;
      }
    },
    checkSingleDevice(device) {
      this.deviceList.forEach(dev => {
        if (device.id == dev.id) {
          dev.check = true;
        } else {
          dev.check = false;
        }
      });
    },
    clearDevices() {
      this.deviceList.forEach(dev => {
        dev.check = false;
      });
    },
    getCheckDeviceList() {
      this.scenario.terminalList = [];
      this.devices.forEach(doc => {
        if (doc.check == true) {
          this.scenario.terminalList.push(doc.id);
        }
      });
    },
    checkDays() {
      this.scenario.days = [];
      this.dayList.forEach(item => {
        if (item.check == true) {
          this.scenario.days.push(item.value);
        }
      });
    },
    async saveScenario() {
      await this.getCheckDeviceList();
      if (
        this.scenario.name == "" ||
        this.scenario.time == null ||
        this.scenario.terminalList.length == 0
      ) {
        alertify.warning(this.$ml.get("alerts.pleaseCheckEmptyFields"));
        return;
      }
      if (this.scenario.id && this.scenario.day == 0) {
        alertify.warning(this.$ml.get("alerts.pleaseCheckEmptyFields"));
        return;
      }
      if (!this.scenario.id) {
        try {
          this.isLoading = true;
          await this.checkDays();
          if (this.scenario.days.length == 0) {
            alertify.warning(this.$ml.get("alerts.pleaseCheckEmptyFields"));
            return;
          }
          const response = await this.$axios
            .post("/Scenario", {
              name: this.scenario.name,
              type: this.scenario.type,
              days: this.scenario.days,
              time: this.scenario.time,
              command: this.scenario.command,
              terminalList: this.scenario.terminalList
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                this.backToScenarioList();
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error("Servis Hatası :" + error.message);
          this.isLoading = false;
        }
      } else {
        try {
          this.isLoading = true;
          const response = await this.$axios
            .put("/Scenario", {
              id: this.scenario.id,
              name: this.scenario.name,
              type: this.scenario.type,
              day: this.scenario.day,
              time: this.scenario.time,
              command: this.scenario.command,
              terminalList: this.scenario.terminalList
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
                this.backToScenarioList();
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error("Servis Hatası :" + error.message);
          this.isLoading = false;
        }
      }
    },
    async getDevices() {
      try {
        this.isLoading = true;
        const devices = [];
        const response = await this.$axios
          .get("/Terminal")
          .then(response => {
            response.data.forEach(doc => {
              devices.push({
                id: doc.id,
                no: doc.no,
                name: doc.name,
                ip: doc.ip,
                lastConnectionTime: doc.lastConnectionTime,
                lastConnectionStatus: doc.lastConnectionStatus,
                check: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.devices = devices;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    getCheckDevices() {
      this.deviceList.forEach(doc => {
        this.scenario.terminalList.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getDevices();
    if (this.scenario.id) {
      this.isLoading = true;
      try {
        const response = await this.$axios
          .get("/Scenario/" + this.scenario.id)
          .then(response => {
            this.scenario.name = response.data.name;
            this.scenario.type = response.data.type;
            this.scenario.day = response.data.day;
            this.scenario.time = response.data.time
              ? this.toDateFormat(response.data.time, "ss:dd")
              : "";
            this.scenario.command = response.data.command;
            this.scenario.terminalList = response.data.terminalList;
            this.getCheckDevices();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/scenarios/ScenarioDetails.vue